var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppellation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 9.2C5.61177 9.2 4 7.58823 4 5.6C4 3.61177 5.61177 2 7.6 2C9.58822 2 11.2 3.61177 11.2 5.6C11.2 7.58823 9.58822 9.2 7.6 9.2ZM7.6 7.4C8.59411 7.4 9.4 6.59411 9.4 5.6C9.4 4.60589 8.59411 3.8 7.6 3.8C6.60589 3.8 5.8 4.60589 5.8 5.6C5.8 6.59411 6.60589 7.4 7.6 7.4ZM10 9.05V14L7.6 11.6L5.2 14V9.05C6.64073 10.0596 8.55927 10.0596 10 9.05Z",
    fill: "#CECECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppellation);
export default __webpack_public_path__ + "static/media/appellation.b66157d2.svg";
export { ForwardRef as ReactComponent };